angular.module('dpw.services').factory('dpwAppAccessService', [function () {
    var AppAccess = {
        ReadOnly: 'RO',
        ReadWrite: 'RW'
    };

    var appAccessConfig = {};

    appAccessConfig[AppAccess.ReadOnly] = {
        id: AppAccess.ReadOnly,
        label: 'Read-only'
    };

    appAccessConfig[AppAccess.ReadWrite] = {
        id: AppAccess.ReadWrite,
        label: 'Read & write'
    };

    return {
        AppAccess: AppAccess,
        getConfig: getConfig
    };

    function getConfig() {
        return _.map(AppAccess, function (accessId) {
            return appAccessConfig[accessId];
        });
    }
}]);
